import React from 'react';
import { Box, Typography } from '@mui/material';
import { CheckCircleRounded } from '@mui/icons-material';
import { radius } from '../../theme';

// One shared "selectable option tile" (radio-like choice card) — replaces
// Profile's two independent in-file variants (SelectCard and the inline
// gender tile). layout="horizontal" mirrors SelectCard, "vertical" mirrors
// the gender tile.
export default function SelectableCard({
  icon,
  label,
  desc,
  selected,
  onClick,
  layout = 'horizontal',
  color = 'primary.main',
}) {
  const isHorizontal = layout === 'horizontal';

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: isHorizontal ? 'row' : 'column',
        alignItems: 'center',
        gap: isHorizontal ? 1.5 : 0.75,
        p: isHorizontal ? 2 : 1.5,
        borderRadius: radius.lg,
        border: '2px solid',
        borderColor: selected ? color : 'divider',
        bgcolor: selected ? 'action.selected' : 'transparent',
        cursor: 'pointer',
        transition: 'border-color 0.15s ease, background-color 0.15s ease',
        userSelect: 'none',
      }}
    >
      {icon && (
        <Box sx={{ display: 'flex', color: selected ? color : 'text.secondary' }}>{icon}</Box>
      )}
      <Box sx={{ flex: isHorizontal ? 1 : undefined, minWidth: 0 }}>
        <Typography
          variant={isHorizontal ? 'body1' : 'body2'}
          sx={{ fontWeight: selected ? 600 : 400 }}
        >
          {label}
        </Typography>
        {desc && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {desc}
          </Typography>
        )}
      </Box>
      {isHorizontal && selected && <CheckCircleRounded sx={{ color }} fontSize="small" />}
    </Box>
  );
}
